/**
 * KeyboardHelpModal - Displays keyboard shortcuts help
 * Extracted from App.js Dashboard component
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const KeyboardHelpModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" 
      onClick={onClose}
    >
      <Card className="w-full max-w-2xl glass-healthcare" onClick={(e) => e.stopPropagation()}>
        <CardHeader>
          <CardTitle className="flex items-center text-2xl">
            <span className="mr-2">⌨️</span>
            Keyboard Shortcuts
          </CardTitle>
          <p className="text-gray-600 mt-2">Save time with these keyboard shortcuts</p>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-3">
              <h3 className="font-semibold text-gray-900 mb-2">Actions</h3>
              <ShortcutRow label="New Client" shortcut="Ctrl+N" />
              <ShortcutRow label="Schedule Session" shortcut="Ctrl+S" />
              <ShortcutRow label="New Progress Note" shortcut="Ctrl+P" />
              <ShortcutRow label="Global Search" shortcut="Ctrl+K" />
            </div>
            
            <div className="space-y-3">
              <h3 className="font-semibold text-gray-900 mb-2">Navigation</h3>
              <ShortcutRow label="Today's View" shortcut="T" />
              <ShortcutRow label="Dashboard" shortcut="D" />
              <ShortcutRow label="Client Care" shortcut="C" />
              <ShortcutRow label="Analytics" shortcut="A" />
            </div>
          </div>
          
          <div className="mt-6 pt-4 border-t border-gray-200">
            <ShortcutRow label="Close/Cancel" shortcut="Escape" />
            <ShortcutRow label="Show this help" shortcut="?" className="mt-3" />
          </div>
          
          <div className="mt-6 text-center">
            <Button 
              onClick={onClose} 
              className="bg-gradient-to-r from-sky-600 to-cyan-600"
            >
              Got it!
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

// Helper component for shortcut rows
const ShortcutRow = ({ label, shortcut, className = '' }) => (
  <div className={`flex justify-between items-center ${className}`}>
    <span className="text-gray-700">{label}</span>
    <kbd className="px-3 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono">
      {shortcut}
    </kbd>
  </div>
);

export default KeyboardHelpModal;
